import React, {useEffect, useState} from 'react';
import axios from "../../services/MyAxios";
import {Bar} from "react-chartjs-2";

function TimelineChart({startDate, endDate, url, modelId, onSaleSumUpdated}) {
    const [chartData, setChartData] = useState({})
    const [options, setOptions] = useState({})

    const chart = (data) => {
        setChartData({
            datasets: [
                {
                    fill: false,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: data
                }
            ]
        })
        setOptions({
            legend: {
                display: false,
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    bounds: 'data',
                    time: {
                        minUnit: 'day',
                        displayFormats: {
                            // day: 'DD/MM/YYYY'
                        },
                    },
                    ticks: {
                        source: 'auto'
                    },
                    position: 'bottom',
                    gridLines: {
                        display: true,
                        offsetGridLines: true,
                        drawBorder: true,
                        drawTicks: true,
                    },
                }],
                yAxes: [{
                    type: 'linear',
                    ticks: {
                        beginAtZero: true,
                    },
                    position: 'left',
                }],
            }
        })
    }

    function requestFreshData() {
        if (startDate == null || modelId == null) return;
        let params;
        if (endDate){
            params = {
                start_date: startDate.format(),
                end_date: endDate.format()
            };
        } else {
            params = {
                single_date: startDate.format(),
            };
        }
        axios
            .get(url, {
                params: params
            })
            .then((response) => {
                chart(response.data.chart_data)
                onSaleSumUpdated(response.data.sum)
            });
    }

    useEffect(() => {
        requestFreshData();
    }, [startDate, endDate, modelId])

    return <Bar data={chartData}
                options={options}/>
}

export default TimelineChart
